module.exports = __webpack_public_path__ + "img/poolBanner.1d57aee7.png";